import React, { Component } from "react";
import themePropTypes from "../theme-prop-types";

class Slider extends Component {
  getSelectedOption = field => {
    let selectedOption = null;
    field.options.forEach(option => {
      if (field.value) {
        if (field.value === option.value) {
          selectedOption = option;
        }
      } else if (option.selected) {
        selectedOption = option;
      }
    });
    return selectedOption;
  };

  render() {
    const {
      field,
      handleChange,
      invalid,
      components: { Pills },
      isRadioGroup,
      label
    } = this.props;
    const { options } = field;
    const selectedOption = this.getSelectedOption(field);
    return (
      <div className='td-slider-web-sdk'>
        <Pills
          options={options.filter(option => !!option.value)}
          value={selectedOption ? selectedOption.value : "NOT_SELECTED"}
          onChange={value =>
            handleChange(
              field,
              options.find(o => o.value === value)
            )
          }
          name={field.name}
          invalid={invalid}
          isRadioGroup={isRadioGroup}
          label={label}
        />
      </div>
    );
  }
}

Slider.propTypes = themePropTypes.slider;

export default Slider;
